import { withStyles } from "@material-ui/core/styles";
import { TextField, MenuItem } from "@material-ui/core";
import React from "react";

const StyledMenuItem = withStyles({
    root: {
        padding: '4px 12px',
        fontSize: '1rem',
        minHeight: '32px',
        backgroundColor: '#ffffff',
        color: '#000000',
        transition: 'none !important',
        boxShadow: 'none !important',
        '&:hover': {
            backgroundColor: '#808080',
            color: '#FFFFFF',
        },
        '&:focus': {
            backgroundColor: '#e9ecef',
            color: '#000000',
        },
        '&.Mui-selected': {
            backgroundColor: '#808080',
            color: '#ffffff',

            '&:hover': {
                backgroundColor: '#666666',
            },
        },
        '.MuiMenu-root &:not(:hover).Mui-selected': {
            backgroundColor: '#ffffff',
            color: '#000000',
        },
    },
})(MenuItem);

export const CustomSelect = withStyles((theme) => ({
    root: {
        '& .MuiInputLabel-outlined': {
            position: 'relative',
            marginBottom: '8px',
            fontWeight: '500',
            fontSize: '1rem',
            color: (props) => props.theme?.labelColor || '#000000',
            transform: 'none',
            '&.Mui-focused': {
                color: (props) => props.theme?.labelFocusColor || '#000000',
            },
        },

        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'none',
            marginBottom: '8px',
            backgroundColor: 'transparent',
            padding: 0,
        },

        '& .MuiOutlinedInput-root': {
            backgroundColor: (props) => props.theme?.inputBg || '#ffffff',
            border: (props) => `1px solid ${props.theme?.inputBorder || '#dee2e6'}`,
            borderRadius: (props) => props.theme?.borderRadius || '4px',

            '&.Mui-focused': {
                backgroundColor: (props) => props.theme?.focusBg || props.theme?.inputBg || '#ffffff',
                borderColor: (props) => props.theme?.focusBorder || '#80bdff',
                boxShadow: (props) => props.theme?.focusShadow || '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
                outline: 'none',
            },
            '&:hover': {
                borderColor: (props) => props.theme?.hoverBorder || '#80bdff',
                backgroundColor: (props) => props.theme?.hoverBg || props.theme?.inputBg,
            },
            '& fieldset': {
                border: 'none',
            },
        },
        '& .MuiSelect-select': {
            padding: (props) => props.theme?.inputPadding || '0.5rem 0.75rem',
            fontSize: '1rem',
            color: (props) => props.theme?.inputColor || '#000000',
            '&::placeholder': {
                color: (props) => props.theme?.placeholderColor || '#6c757d',
                opacity: 1,
            },
            '&:focus': {
                backgroundColor: '#FFFFFF',
            },
        },
    },
}))((props) => {
    const { theme, items, children, ...otherProps } = props;

    return (
        <TextField
            {...otherProps}
            select
            variant="outlined"
            fullWidth
            SelectProps={{
                MenuProps: {
                    transitionDuration: 0,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                    PaperProps: {
                        style: {
                            marginTop: '4px',
                            animation: 'none',
                            transition: 'none',
                            border: '1px solid #808080',
                            boxShadow: 'none',
                        },
                    },
                    MenuListProps: {
                        style: {
                            padding: '0',
                        },
                    },
                },
            }}
        >
            {items ? items.map((item) => (
                <StyledMenuItem
                    key={item.value}
                    value={item.value}
                >
                    {item.label}
                </StyledMenuItem>
            )) : children}
        </TextField>
    );
});
